export let OpsgenieScope = /*#__PURE__*/function (OpsgenieScope) {
  OpsgenieScope["OpsgenieAlert"] = "opsgenie.alert";
  return OpsgenieScope;
}({});